import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getApi, postApi } from "../../utils/api";
import {
  ADMIN_UPLOAD_USER_PHOTO,
  API_USER_UPDATE_EMPLOYEE,
  GET_EMPLOYEE_PROFILE_BY_EMPID,
  API_GET_TECHSTACKS_LIST,
  API_MY_INSURANCE,
  API_PHASE2_LIST,
  USER_PROFILE,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import Salary from "../Employee/Salary";
import WorkExperience from "../Employee/WorkExperience";
import EmployeeAsset from "../Employee/EmployeeAsset";
import OrgChartExample from "../OrgChartExample";
import IndexChart from "../org-diagram";
import Education from "../Employee/Education";
import Dependents from "../Employee/Dependent";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import EmployeeType from "./EmployeeType";
import EmployeeAccess from "./EmployeeAccess";
import EditEmployee from "./EditEmployee";
import moment from "moment";
import PageTitle from "../../components/PageTitle";
import axios from "axios";
import {
  displayFormatDate,
  formatCalendarDateDisplay,
  formatCalendarDateForInput,
  getEmployeePhone,
  getFirstDefinedField,
} from "../../utils/helpers";
import { API_GET_EMPLOYEE_FILE } from "../../config/Endpoints";
import maleDefaultImg from "../../Styles/images/male_employee_default_img.png";
import femaleDefaultImg from "../../Styles/images/female_employee_default_img.png";
import { employeeTypeOptions } from "../../options/employeeTypeOptions";
import { emergencyContactRelationOptions } from "../../options/emergencyContactRelationOptions.ts";
import SortableTable from "../../components/SortableTable";
import TruncateText from "../../components/TruncateText";
import ProfileBankDetails from "../Employee/ProfileBankDetails";
import EmployeeInsuranceTab from "../../v2/components/features/employee-insurance/employee-insurance-tab.tsx";
import UploadDocument from "../Employee/UploadDocument";
import { isUsEmployeeLocation } from "../../v2/hooks/use-is-us-employee.ts";
import {
  isValidSsn,
  normalizeSsn,
  SSN_VALIDATION_MESSAGE,
} from "../../v2/utils/ssn-validation.ts";
import { useSqeLabs } from "../../v2/hooks/use-sqe-labs.ts";
import { isSQEEmployeeType } from "../../v2/utils/sqe-labs-navigation-access.ts";
import { SqeShiftTiming } from "../../v2/components/features/sqe-shift-timing/sqe-shift-timing.tsx";
import { useCompanyNameOptions } from "../../v2/hooks/use-company-name-options.ts";
import { isInsuranceEligibleLocation } from "../../v2/utils/insurance-eligibility.ts";
import {
  EmployeeCertificationsView,
  EmployeeTechStackView,
} from "../../v2/components/features/employee-profile-skills/employee-profile-skills.tsx";
function formatURL(input) {
  if (!input || input.trim() === "") {
    return "";
  }
  try {
    const url = new URL(input);

    if (url.protocol !== "https:") return null;

    // must end with .com
    if (!url.hostname.endsWith(".com")) return null;
    if (url.hostname === ".com" || url.hostname.startsWith(".")) {
      return null;
    }
    if (url.hostname.includes("..") || url.pathname.includes("..")) return null;

    // block multiple slashes after domain
    if (/\/\/{2,}/.test(url.pathname)) return null;

    return url.toString();
  } catch {
    return null;
  }
}

function getLeaveManagerDisplayName(personalDetail, userData) {
  const name =
    personalDetail?.leaveManagerName ??
    userData?.leaveManagerName ??
    "";
  return name && String(name).trim() ? name : "-";
}

function displayEmployeeStatus(status) {
  const normalizedStatus = String(status ?? "").trim().toUpperCase();
  const labels = {
    VERIFIED: "Working",
    BLOCKED: "Blocked",
    LEFTOUT: "Left Organization",
  };
  return labels[normalizedStatus] || status || "-";
}

const NOTICE_PERIOD_PRESET_DAYS = ["30", "60", "90"];
const NOTICE_PERIOD_OPTIONS = [
  { value: "30", label: "1 Month" },
  { value: "60", label: "2 Months" },
  { value: "90", label: "3 Months" },
  { value: "custom", label: "Custom" },
];

function getNoticePeriodPreset(days) {
  const value = days ? String(days) : "";
  if (!value) return "";
  return NOTICE_PERIOD_PRESET_DAYS.includes(value) ? value : "custom";
}

function formatNoticePeriodDays(days) {
  const parsedDays = Number(days);
  if (!Number.isFinite(parsedDays) || parsedDays <= 0) return "-";

  if (parsedDays % 30 === 0) {
    const months = parsedDays / 30;
    return `${months} ${months === 1 ? "Month" : "Months"}`;
  }

  return `${parsedDays} ${parsedDays === 1 ? "Day" : "Days"}`;
}

const EmployeeProfile = ({ title, description }) => {
  const { state } = useLocation();
  const { data, cachedImage } = state || {};
  const [userData, setUserData] = useState(data ? data : {});
  const isUsEmployee = isUsEmployeeLocation(userData?.personalDetail?.location);
  const showInsuranceDetailsTab = isInsuranceEligibleLocation(
    userData?.personalDetail?.location,
    userData?.personalDetail?.employeeType ?? userData?.personalDetail?.empType,
  );
  const accessToken = Cookies.get("accessToken");
  const companyNames = useCompanyNameOptions();
  const [showBankDetailsTab, setShowBankDetailsTab] = useState(false);
  const [insuranceDetails, setInsuranceDetails] = useState(null);
  const [insuranceDetailsLoading, setInsuranceDetailsLoading] = useState(true);
  const [insuranceRefreshKey, setInsuranceRefreshKey] = useState(0);
  const [documentUploadLoading, setDocumentUploadLoading] = useState(true);
  const getDefaultImage = (gender) =>
    gender?.toLowerCase() === "female" ? femaleDefaultImg : maleDefaultImg;

  const [selectedImage, setSelectedImage] = useState(
    () => cachedImage || getDefaultImage(userData?.personalDetail?.gender),
  );
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [isBasicInfoEdit, setIsBasicInfoEdit] = useState(false);
  const [isWorkEdit, setIsWorkEdit] = useState(false);
  const [isPersonalDetailEdit, setIsPersonalDetailEdit] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const isSqeLabs = useSqeLabs();
  const showSqeShiftTiming = isSqeLabs && isSQEEmployeeType(
    userData?.personalDetail?.employeeType ?? userData?.personalDetail?.empType,
  );
  const profileEmail = isSqeLabs
    ? userData?.personalDetail?.primaryEmail || "-"
    : userData?.personalDetail?.ccEmail || "-";
  const employeePhone = getEmployeePhone(
    userData?.personalDetail?.phoneNumber,
    userData?.personalDetail?.location,
  );

  const educationColumns = [
    {
      key: "highestDegree",
      label: "Degree",
    },
    {
      key: "college",
      label: "College",
    },
    {
      key: "fromDate",
      label: "From",
      compare: (a, b) => new Date(a.fromDate) - new Date(b.fromDate),
      render: (item) => displayFormatDate(item.fromDate),
    },
    {
      key: "toDate",
      label: "To",
      compare: (a, b) => new Date(a.toDate) - new Date(b.toDate),
      render: (item) => displayFormatDate(item.toDate),
    },
  ];

  const experienceColumns = [
    {
      key: "jobTitle",
      label: "Job Title",
    },
    {
      key: "previousCompany",
      label: "Previous Company",
    },
    {
      key: "fromDate",
      label: "From",
      compare: (a, b) => new Date(a.fromDate) - new Date(b.fromDate),
      render: (item) => displayFormatDate(item.fromDate),
    },
    {
      key: "toDate",
      label: "To",
      compare: (a, b) => new Date(a.toDate) - new Date(b.toDate),
      render: (item) => displayFormatDate(item.toDate),
    },
    {
      key: "jobDescription",
      label: "Description",
      sortable: false,
      render: (item) => (
        <TruncateText text={item.jobDescription?.trim() || "-"} />
      ),
    },
  ];

  const dependentsColumns = [
    {
      key: "name",
      label: "Name",
    },
    {
      key: "gender",
      label: "Gender",
    },
    {
      key: "dob",
      label: "DOB",
      compare: (a, b) => new Date(a.dob) - new Date(b.dob),
      render: (item) => displayFormatDate(item.dob),
    },
    {
      key: "relationship",
      label: "Relation",
    },
    {
      key: "number",
      label: "Mobile Number",
    },
  ];

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    bloodGroup: "",
    dob: "",
    employeeSubType: "",
    employeeType: "",
    flag: "",
    isTech: "",
    trailHead: "",
    techStack: "",
    aadharNumber: "",
    panCardNumber: "",
    ssn: "",
    zipCode: "",
    passportNumber: "",
    gender: "",
    joiningDate: "",
    confirmationDate: "",
    noticePeriodDays: "",
    noticePeriodMode: "preset",
    noticePeriodCustomDays: "1",
    noticePeriodCustomUnit: "days",
    maritalStatus: "",
    anniversaryDate: "",
    phoneNumber: "",
    alternateNumber: "",
    presentAddress: "",
    permanentAddress: "",
    personalEmail: "",
    currentLocation: "",
    joiningLocation: "",
    alternateName: "",
    relationWithAlternateNo: "",
  });
  const [errors, setErrors] = useState({});
  const [techStacks, setTechStacks] = useState([]);
  const isTechnicalOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  useEffect(() => {
    const fetchTechStacks = async () => {
      try {
        const res = await axios.get(API_GET_TECHSTACKS_LIST, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (res.status === 200) {
          setTechStacks(
            res.data.filter((techStack) => {
              const name = techStack.name?.trim().toUpperCase();
              return name !== "OTHERS" && name !== "QA";
            }),
          );
        }
      } catch (error) {
        console.error("Something Went Wrong!", error);
      }
    };

    fetchTechStacks();
  }, []);

  useEffect(() => {
    if (userData) {
      setFormData({
        firstName: userData?.personalDetail?.firstName
          ? userData.personalDetail.firstName.charAt(0).toUpperCase() +
            userData.personalDetail.firstName.slice(1).toLowerCase()
          : "",
        middleName: userData?.personalDetail?.middleName
          ? userData.personalDetail.middleName.charAt(0).toUpperCase() +
            userData.personalDetail.middleName.slice(1).toLowerCase()
          : "",
        lastName: userData?.personalDetail?.lastName
          ? userData.personalDetail.lastName.charAt(0).toUpperCase() +
            userData.personalDetail.lastName.slice(1).toLowerCase()
          : "",
        bloodGroup: userData?.personalDetail?.bloodGroup,
        dob: formatCalendarDateForInput(userData?.personalDetail?.dob),
        aadharNumber: userData?.personalDetail?.aadharNum,
        employeeFlag: userData?.personalDetail?.location || "",
        isTech:
          userData?.personalDetail?.isTech !== undefined &&
          userData?.personalDetail?.isTech !== null
            ? String(userData?.personalDetail?.isTech)
            : "",
        trailHead: userData?.personalDetail?.trailHead || "",
        techStack: userData?.personalDetail?.techStack || "",
        panCardNumber: userData?.personalDetail?.panNum,
        ssn: userData?.personalDetail?.ssn || "",
        zipCode: userData?.personalDetail?.zipCode ?? "",
        passportNumber: userData?.personalDetail?.passportNum,
        gender: userData?.personalDetail?.gender,
        joiningDate: formatCalendarDateForInput(userData?.personalDetail?.doj),
        confirmationDate: formatCalendarDateForInput(
          getFirstDefinedField(
            userData?.personalDetail,
            "confirmationDate",
            "comconfirmationDate",
          ),
        ),
        noticePeriodDays: userData?.personalDetail?.noticePeriodDays || "",
        noticePeriodMode: NOTICE_PERIOD_PRESET_DAYS.includes(
          String(userData?.personalDetail?.noticePeriodDays || ""),
        )
          ? "preset"
          : "custom",
        noticePeriodCustomDays: (() => {
          const days = Number(userData?.personalDetail?.noticePeriodDays);
          if (!Number.isFinite(days) || days <= 0) return "1";
          if (days % 30 === 0 && !NOTICE_PERIOD_PRESET_DAYS.includes(String(days))) {
            return String(days / 30);
          }
          return String(days);
        })(),
        noticePeriodCustomUnit: (() => {
          const days = Number(userData?.personalDetail?.noticePeriodDays);
          if (!Number.isFinite(days) || days <= 0) return "days";
          if (days % 30 === 0 && !NOTICE_PERIOD_PRESET_DAYS.includes(String(days))) {
            return "months";
          }
          return "days";
        })(),
        employeeType: userData?.personalDetail?.employeeType || "",
        employeeSubType: userData?.personalDetail?.employeeSubType || "",
        maritalStatus: userData?.personalDetail?.maritalStatus,
        anniversaryDate: userData?.personalDetail?.anniversaryDate,
        phoneNumber: userData?.personalDetail?.phoneNumber,
        alternateNumber: userData?.personalDetail?.alternateNumber,
        presentAddress: userData?.personalDetail?.presentAddress,
        permanentAddress: userData?.personalDetail?.permanentAddress,
        personalEmail: userData?.personalDetail?.personalEmail || "",
        currentLocation: userData?.personalDetail?.currentLocation || "",
        joiningLocation: userData?.personalDetail?.joiningLocation || "",
        alternateName: userData?.personalDetail?.alternateName,
        relationWithAlternateNo:
          userData?.personalDetail?.relationWithAlternateNo,
      });
    }
    console.log(formData);
  }, [userData]);

  useEffect(() => {
    if (cachedImage) {
      setIsImageLoading(false);
      return;
    }

    const fetchProfileImage = async () => {
      // Helper function to get default image based on gender
      const getDefaultImage = (gender) =>
        gender?.toLowerCase() === "female" ? femaleDefaultImg : maleDefaultImg;

      if (userData?.personalDetail?.photoPath?.includes("photoDir")) {
        const parts = userData?.personalDetail?.photoPath?.split("/");
        const result = parts.slice(3).join("/");

        try {
          const res = await axios.get(API_GET_EMPLOYEE_FILE, {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: { filepath: result },
            responseType: "blob",
          });

          if (res.status === 200) {
            const imageUrl = URL.createObjectURL(res.data);
            setSelectedImage(imageUrl);
          } else {
            setSelectedImage(getDefaultImage(userData?.personalDetail?.gender));
          }
        } catch (err) {
          console.error("Error fetching image:", err);
          setSelectedImage(getDefaultImage(userData?.personalDetail?.gender));
        }
      } else {
        setSelectedImage(getDefaultImage(userData?.personalDetail?.gender));
      }
      setIsImageLoading(false);
    };

    fetchProfileImage();
  }, [
    userData?.personalDetail?.photoPath,
    userData?.personalDetail?.gender,
    cachedImage,
  ]);

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;
    let newValue = value;
    if (name === "isTech") {
      newValue = value === "true";
    }
    if (name === "zipCode") {
      newValue = value.replace(/\D/g, "").slice(0, 5);
    }
    if (name === "ssn") {
      newValue = normalizeSsn(value);
    }
    if (name === "alternateNumber") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    }
    if (name === "alternateName" || name === "relationWithAlternateNo") {
      newValue = value.replace(/\d/g, "");
    }
    if (name === "panCardNumber") {
      newValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
    }
    if (name === "passportNumber") {
      newValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, isUsEmployee ? 9 : 8);
    }

    setErrors((previousErrors) => ({
      ...previousErrors,
      [name]:
        name === "alternateNumber" && /\D/.test(value)
          ? "Emergency contact number must contain digits only."
          : name === "alternateName" && /\d/.test(value)
            ? "Emergency contact name must not contain numbers."
            : name === "relationWithAlternateNo" && /\d/.test(value)
              ? "Relationship must not contain numbers."
          : "",
    }));

    if (type === "date") {
      const year = value.split("-")[0];
      if (year.length <= 4) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: newValue,
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: newValue,
        ...(name === "employeeType" && newValue !== "REGULAR"
          ? { employeeSubType: "" }
          : {}),
      }));
    }
  };

  const computeNoticePeriodDays = (value, unit) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return "1";
    }
    return unit === "months" ? String(parsed * 30) : String(parsed);
  };

  const handleNoticePeriodPresetChange = (event) => {
    const { value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      noticePeriodMode: value === "custom" ? "custom" : "preset",
      noticePeriodDays:
        value === "custom"
          ? computeNoticePeriodDays(
              prevFormData.noticePeriodCustomDays,
              prevFormData.noticePeriodCustomUnit,
            )
          : value,
    }));
  };

  const handleNoticePeriodCustomDaysChange = (event) => {
    const customDays = event.target.value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      noticePeriodMode: "custom",
      noticePeriodCustomDays: customDays,
      noticePeriodDays: computeNoticePeriodDays(
        customDays,
        prevFormData.noticePeriodCustomUnit,
      ),
    }));
  };

  const handleNoticePeriodCustomUnitChange = (event) => {
    const customUnit = event.target.value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      noticePeriodMode: "custom",
      noticePeriodCustomUnit: customUnit,
      noticePeriodDays: computeNoticePeriodDays(
        prevFormData.noticePeriodCustomDays,
        customUnit,
      ),
    }));
  };

  // Get today's date in the format yyyy-mm-dd
  const today = new Date().toISOString().split("T")[0];
  // Function to get the minimum selectable date (today's date - 30 days)
  function getMinDate() {
    const today = new Date();
    const minDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 30,
    );
    return minDate.toISOString().split("T")[0];
  }

  function getMaxDate() {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    return today.toISOString().split("T")[0];
  }

  const handleImageClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/jpeg, image/jpg, image/png"; // Accepts only JPEG, JPG, and PNG files
    const acceptedFileTypes = ["image/jpeg", "image/png", "image/jpeg"];

    input.onchange = (event) => {
      const selectedFile = event.target.files[0];
      const maxFileSize = 8 * 1024 * 1024; // 8 MB in bytes

      if (!acceptedFileTypes.includes(selectedFile.type)) {
        // File type is not supported
        toast.error(
          "Unsupported file type. Please select a valid image (PNG, JPEG and JPG) file.",
          {
            position: toast.POSITION.TOP_RIGHT,
          },
        );
        event.target.value = null; // Clear the file input
      } else if (selectedFile.size > maxFileSize) {
        // File size exceeds the maximum allowed size
        toast.error("File size exceeds the maximum limit of 8MB.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        event.target.value = null; // Clear the file input
      } else {
        setSelectedImageFile(selectedFile);
        setSelectedImage(URL.createObjectURL(selectedFile));
      }
    };
    input.click();
  };

  const handleUploadClick = async (e) => {
    e.preventDefault();
    if (selectedImage) {
      setIsImageLoading(true);
      const formData = new FormData();
      formData.append("photo", selectedImageFile);
      await postApi(
        ADMIN_UPLOAD_USER_PHOTO + `?employeeId=${userData?.personalDetail?.id}`,
        formData,
        accessToken,
      )
        .then((res) => {
          if (res.status === 200) {
            setIsImageLoading(false);
            toast.success("Profile Upload Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setSelectedImageFile(null);
          } else {
            setIsImageLoading(false);
          }
        })
        .catch((e) => {
          console.error("Upload error:", e);
          setIsImageLoading(false);
        });
    } else {
      toast.error("No image selected.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    if (data) {
      fetchUser();
    }
  }, [data]);

  useEffect(() => {
    const employeeId = userData?.personalDetail?.id ?? data;
    if (!employeeId || !accessToken) {
      setShowBankDetailsTab(false);
      return;
    }

    getApi(
      `${API_PHASE2_LIST}?employeeId=${encodeURIComponent(
        String(employeeId),
      )}&currentPage=1&pageSize=1`,
      accessToken,
    )
      .then((res) => {
        if (res.status === 200) {
          const payload = res?.data?.data ?? res?.data;
          const content =
            payload?.content ??
            payload?.data ??
            (Array.isArray(payload) ? payload : null);
          const list = Array.isArray(content) ? content : [];
          const employeeRow = list.find(
            (item) =>
              Number(item?.employee?.id ?? item?.employeeId) ===
              Number(employeeId),
          ) ?? list[0];
          setShowBankDetailsTab(employeeRow?.bankDetails != null);
        } else {
          setShowBankDetailsTab(false);
        }
      })
      .catch(() => {
        setShowBankDetailsTab(false);
      });
  }, [userData?.personalDetail?.id, data, accessToken]);

  useEffect(() => {
    const employeeId = userData?.personalDetail?.id ?? data;
    let active = true;

    if (!employeeId || !accessToken || !showInsuranceDetailsTab) {
      setInsuranceDetails(null);
      setInsuranceDetailsLoading(false);
      return () => {
        active = false;
      };
    }

    setInsuranceDetailsLoading(true);
    getApi(
      `${API_MY_INSURANCE}/${encodeURIComponent(String(employeeId))}`,
      accessToken,
    )
      .then((res) => {
        if (!active) return;
        const responsePayload = res?.data?.data ?? res?.data ?? null;
        const payload = Array.isArray(responsePayload)
          ? responsePayload[0] ?? null
          : responsePayload;

        if (!payload || typeof payload !== "object") {
          setInsuranceDetails(null);
          return;
        }

        const self = payload.insuranceDetails ?? payload.employeeInsurance ?? payload;
        const familyPayload =
          payload.familyInsuranceDetails ?? payload.familyInsurance ?? payload;
        const family = payload.familyInsuranceDetails ?? {
          spouseInsurance:
            familyPayload.spouseInsurance ??
            (familyPayload.spouseInsuranceNumber ||
            familyPayload.spouseName ||
            familyPayload.spouseDob
              ? {
                  name: familyPayload.spouseName,
                  dob: familyPayload.spouseDob,
                  insuranceNumber: familyPayload.spouseInsuranceNumber,
                  insuranceFrom: familyPayload.spouseInsuranceFrom,
                  insuranceTo: familyPayload.spouseInsuranceTo,
                  insuranceSoftCopy: familyPayload.spouseInsuranceSoftCopy,
                }
              : null),
          childInsurance:
            familyPayload.childInsurance ??
            (familyPayload.childInsuranceNumber ||
            familyPayload.childName ||
            familyPayload.childDob ||
            familyPayload.childGender
              ? {
                  name: familyPayload.childName,
                  dob: familyPayload.childDob,
                  gender: familyPayload.childGender,
                  insuranceNumber: familyPayload.childInsuranceNumber,
                  insuranceFrom: familyPayload.childInsuranceFrom,
                  insuranceTo: familyPayload.childInsuranceTo,
                  insuranceSoftCopy: familyPayload.childInsuranceSoftCopy,
                }
              : null),
        };

        setInsuranceDetails({
          ...self,
          id: self.id ?? self.insuranceId ?? payload.id ?? payload.insuranceId,
          insuranceId:
            self.insuranceId ?? self.id ?? payload.insuranceId ?? payload.id,
          familyInsuranceDetails: family,
          childStatus:
            payload.childStatus === true || Boolean(family?.childInsurance),
          maritalStatus:
            payload.maritalStatus ?? userData?.personalDetail?.maritalStatus,
        });
      })
      .catch(() => {
        if (active) setInsuranceDetails(null);
      })
      .finally(() => {
        if (active) setInsuranceDetailsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [
    userData?.personalDetail?.id,
    userData?.personalDetail?.maritalStatus,
    data,
    accessToken,
    insuranceRefreshKey,
    showInsuranceDetailsTab,
  ]);

  const fetchUser = () => {
    setIsLoading(true);
    getApi(`${GET_EMPLOYEE_PROFILE_BY_EMPID}/${data}`, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setUserData(res.data.data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleEditCollapse = () => {
    setIsPersonalDetailEdit(false);
    setIsWorkEdit(false);
    setIsBasicInfoEdit(false);
    handleClose();
  };

  const handleUpdateUserDetails = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    const editingSection = isPersonalDetailEdit
      ? "personal"
      : isWorkEdit
        ? "work"
        : "basic";

    if (editingSection === "personal" && isUsEmployee) {
      const ssn = String(formData.ssn ?? "").trim();
      const zipCode = String(formData.zipCode ?? "").trim();

      if (!isValidSsn(ssn)) {
        validationErrors.ssn = SSN_VALIDATION_MESSAGE;
      }
      if (!/^\d{5}$/.test(zipCode)) {
        validationErrors.zipCode = "Enter a valid 5-digit ZIP Code.";
      }
    } else if (editingSection === "personal") {
      const panCardNumber = String(formData.panCardNumber ?? "")
        .trim()
        .toUpperCase();

      if (!/^[A-Z]{5}\d{4}[A-Z]$/.test(panCardNumber)) {
        validationErrors.panCardNumber =
          "Enter a valid PAN number (for example, ABCDE1234F).";
      }
    }

    if (editingSection === "personal") {
      const passportNumber = String(formData.passportNumber ?? "")
        .trim()
        .toUpperCase();
      if (
        passportNumber &&
        !(isUsEmployee
          ? /^[A-Z0-9]{6,9}$/.test(passportNumber)
          : /^[A-Z]\d{7}$/.test(passportNumber))
      ) {
        validationErrors.passportNumber = isUsEmployee
          ? "Enter a valid US passport number with 6 to 9 letters or digits (for example, A12345678)."
          : "Passport number must contain 1 letter followed by 7 digits.";
      }
      if (/\d/.test(String(formData.alternateName ?? ""))) {
        validationErrors.alternateName =
          "Emergency contact name must not contain numbers.";
      }
      if (/\d/.test(String(formData.relationWithAlternateNo ?? ""))) {
        validationErrors.relationWithAlternateNo =
          "Relationship must not contain numbers.";
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (
      editingSection === "work" &&
      formData.trailHead &&
      formData.trailHead.trim() !== ""
    ) {
      const sanitized = formatURL(formData.trailHead);
      if (sanitized === null) {
        toast.error("Invalid Trailhead URL.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      formData.trailHead = sanitized;
    }
    const selectedTechStack = String(formData.techStack || "").trim();
    const requestData = {
      ...(isUsEmployee
        ? { ssn: normalizeSsn(formData.ssn), zipCode: formData.zipCode }
        : { aadharNum: formData.aadharNumber, panNum: formData.panCardNumber }),
      alternateNumber: formData.alternateNumber,
      anniversaryDate: formData.anniversaryDate,
      bloodGroup: isUsEmployee ? null : formData.bloodGroup,
      dob: moment(formData.dob).format("yyyy-MM-DD"),
      doj: moment(formData.joiningDate).format("yyyy-MM-DD"),
      confirmationDate: formData.confirmationDate
        ? moment(formData.confirmationDate).format("YYYY-MM-DD")
        : undefined,
      firstName: formData.firstName,
      gender: formData.gender,
      lastName: formData.lastName,
      maritalStatus: formData.maritalStatus,
      employeeSubType:
        formData.employeeType === "REGULAR" ? formData.employeeSubType : "",
      employeeType: formData.employeeType,
      noticePeriodDays:
        formData.noticePeriodDays === ""
          ? undefined
          : Number(formData.noticePeriodDays),
      flag: formData.employeeFlag,
      isTech: formData.isTech,
      trailHead: formData.trailHead,
      techStack:
        selectedTechStack && selectedTechStack.toUpperCase() !== "OTHERS"
          ? selectedTechStack
          : null,
      middleName: formData.middleName || "",
      passportNum: formData.passportNumber,
      permanentAddress: formData.permanentAddress,
      personalEmail: formData.personalEmail,
      currentLocation: formData.currentLocation,
      joiningLocation: formData.joiningLocation,
      phoneNumber: formData.phoneNumber,
      presentAddress: formData.presentAddress,
      alternateName: formData?.alternateName,
      relationWithAlternateNo: formData?.relationWithAlternateNo,
    };

    setIsLoadingUpdate(true);

    await postApi(
      API_USER_UPDATE_EMPLOYEE + "?employeeId=" + userData?.personalDetail?.id,
      requestData,
      accessToken,
    )
      .then((res) => {
        if (res.status === 200) {
          setUserData(res.data.data);
          handleEditCollapse();
          // fetchList();

          setIsLoadingUpdate(false);
          toast.success(
            res.data.message
              ? res.data.message
              : "Employee updated successfully !",
            {
              position: toast.POSITION.TOP_RIGHT,
            },
          );
        } else {
          setIsLoadingUpdate(false);
        }
        // else {
        //   setIsError(true);
        //   setIsLoading(false);
        //   setError("Something went wrong. Please try again!");
        //   setTimeout(() => {
        //     setIsError(false);
        //   }, 4000);
        // }
      })
      .catch((e) => {
        setIsLoadingUpdate(false);

        toast.error(e.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
    console.log(requestData);
  };

  const handleClose = () => {
    if (userData) {
      setFormData({
        firstName: userData?.personalDetail?.firstName,
        middleName: userData?.personalDetail?.middleName || "",
        lastName: userData?.personalDetail?.lastName,
        bloodGroup: userData?.personalDetail?.bloodGroup,
        dob: formatCalendarDateForInput(userData?.personalDetail?.dob),
        aadharNumber: userData?.personalDetail?.aadharNum,
        employeeSubType: userData?.personalDetail?.employeeSubType,
        employeeType: userData?.personalDetail?.employeeType,
        employeeFlag: userData?.personalDetail?.location || "",
        isTech:
          userData?.personalDetail?.isTech !== undefined &&
          userData?.personalDetail?.isTech !== null
            ? String(userData?.personalDetail?.isTech)
            : "",
        trailHead: userData?.personalDetail?.trailHead || "",
        techStack: userData?.personalDetail?.techStack || "",
        panCardNumber: userData?.personalDetail?.panNum,
        ssn: userData?.personalDetail?.ssn || "",
        zipCode: userData?.personalDetail?.zipCode ?? "",
        passportNumber: userData?.personalDetail?.passportNum,
        gender: userData?.personalDetail?.gender,
        joiningDate: formatCalendarDateForInput(userData?.personalDetail?.doj),
        confirmationDate: formatCalendarDateForInput(
          getFirstDefinedField(
            userData?.personalDetail,
            "confirmationDate",
            "comconfirmationDate",
          ),
        ),
        noticePeriodDays: userData?.personalDetail?.noticePeriodDays || "",
        maritalStatus: userData?.personalDetail?.maritalStatus,
        anniversaryDate: userData?.personalDetail?.anniversaryDate,
        phoneNumber: userData?.personalDetail?.phoneNumber,
        alternateNumber: userData?.personalDetail?.alternateNumber,
        presentAddress: userData?.personalDetail?.presentAddress,
        permanentAddress: userData?.personalDetail?.permanentAddress,
        personalEmail: userData?.personalDetail?.personalEmail || "",
        currentLocation: userData?.personalDetail?.currentLocation || "",
        joiningLocation: userData?.personalDetail?.joiningLocation || "",
        alternateName: userData?.personalDetail?.alternateName,
        relationWithAlternateNo:
          userData?.personalDetail?.relationWithAlternateNo,
      });
    }
  };

  return (
    <>
      <div className="wrapper-body px-4 py-2">
        {isLoading && (
          <div className="centered-loader">
            <ThreeDots
              height="100"
              width="100"
              radius="9"
              color="blue"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}

        {!isLoading && (
          // <form id="assign-asset">
          <div className="card">
            <div className="user-type-tag">
              <span
                className={`badge bg-${
                  userData?.personalDetail?.employeeType === "REGULAR"
                    ? "success"
                    : "primary"
                }`}
              >
                {userData?.personalDetail?.employeeType}
              </span>
            </div>
            <div className="row">
              <div className="col-md-2 border-right">
                <div className="d-flex flex-column align-items-center text-center p-3 py-2">
                  {!isImageLoading && (
                    <img
                      className="employee-profile"
                      width="140px"
                      height="140px"
                      alt="employee-profile"
                      src={
                        selectedImage ||
                        getDefaultImage(userData?.personalDetail?.gender)
                      }
                      onError={(e) => {
                        // Prevent infinite loop by checking if already using default
                        if (
                          e.target.src !==
                          getDefaultImage(userData?.personalDetail?.gender)
                        ) {
                          e.target.src = getDefaultImage(
                            userData?.personalDetail?.gender,
                          );
                        }
                      }}

                      // onClick={handleImageClick}
                    />
                  )}
                </div>
              </div>
              <div className="col-md-7 px-0">
                <div className="d-flex flex-column  p-1 py-3">
                  <h4>
                    <b>{userData?.personalDetail?.empName}</b>
                  </h4>
                  <span className="mt-1">
                    {userData?.personalDetail?.designation}
                  </span>
                  {profileEmail !== "-" && (
                    <span className="text-black font-small mt-1">
                      <a href={`mailto:${profileEmail}`}>{profileEmail}</a>
                    </span>
                  )}
                  {userData?.personalDetail?.phoneNumber && (
                    <span className="text-black font-small mb-2">
                      <a href={`tel:${employeePhone.href}`}>
                        <i
                          className="fa fa-mobile"
                          aria-hidden="true"
                          style={{ fontSize: "16px" }}
                        ></i>

                        <span className="ms-1">
                          {employeePhone.display}
                        </span>
                      </a>
                    </span>
                  )}

                  {selectedImage && selectedImageFile && (
                    <button
                      className="btn btn-primary btn-sm w-50"
                      onClick={handleUploadClick}
                    >
                      Upload Image
                    </button>
                  )}
                </div>
              </div>
              <div className="col-md-2">
                {/* <a
                    className="dropdown-item btn-primary"
                    style={{
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdropEmp"
                  >
                    Edit
                  </a> */}
              </div>
              <div className="col-md-1"></div>
            </div>
            <div className="row mt-5">
              <div className="container">
                <ul className="nav nav-tabs" id="myTabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="tab1-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab1"
                      type="button"
                      role="tab"
                      aria-controls="tab1"
                      aria-selected="true"
                    >
                      General Information
                    </button>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab2-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab2"
                      type="button"
                      role="tab"
                      aria-controls="tab2"
                      aria-selected="false"
                    >
                      Job
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab3-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab3"
                      type="button"
                      role="tab"
                      aria-controls="tab3"
                      aria-selected="false"
                    >
                      Leave
                    </button>
                  </li> */}
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab4-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab4"
                      type="button"
                      role="tab"
                      aria-controls="tab4"
                      aria-selected="false"
                    >
                      Assigned Assets
                    </button>
                  </li>
                  {showBankDetailsTab ? (
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="tab13-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#tab13"
                        type="button"
                        role="tab"
                        aria-controls="tab13"
                        aria-selected="false"
                      >
                        Bank Details
                      </button>
                    </li>
                  ) : null}
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab14-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab14"
                      type="button"
                      role="tab"
                      aria-controls="tab14"
                      aria-selected="false"
                    >
                      Document Upload
                    </button>
                  </li>
                  {showInsuranceDetailsTab ? <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab15-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab15"
                      type="button"
                      role="tab"
                      aria-controls="tab15"
                      aria-selected="false"
                    >
                      Insurance Details
                    </button>
                  </li> : null}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab5-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab5"
                      type="button"
                      role="tab"
                      aria-controls="tab5"
                      aria-selected="false"
                    >
                      Performance
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab6-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab6"
                      type="button"
                      role="tab"
                      aria-controls="tab6"
                      aria-selected="false"
                    >
                      Permission
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab7-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab7"
                      type="button"
                      role="tab"
                      aria-controls="tab7"
                      aria-selected="false"
                    >
                      Documents
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab8-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab8"
                      type="button"
                      role="tab"
                      aria-controls="tab8"
                      aria-selected="false"
                    >
                      Salary
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab9-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab9"
                      type="button"
                      role="tab"
                      aria-controls="tab9"
                      aria-selected="false"
                    >
                      Organization Chart
                    </button>
                  </li> */}
                  {/* {userData?.personalDetail?.employeeType !== "REGULAR" && (
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="tab10-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#tab10"
                        type="button"
                        role="tab"
                        aria-controls="tab10"
                        aria-selected="false"
                      >
                        Employee Type
                      </button>
                    </li>
                  )} */}
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="tab11-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#tab11"
                      type="button"
                      role="tab"
                      aria-controls="tab11"
                      aria-selected="false"
                    >
                      Employee Access
                    </button>
                  </li>
                </ul>

                <div className="tab-content" id="myTabsContent">
                  <div
                    className="tab-pane fade show active mt-3"
                    id="tab1"
                    role="tabpanel"
                    aria-labelledby="tab1-tab"
                  >
                    <div className="accordion" id="accordion1">
                      <div className="accordion-item rounded-lg-top">
                        <h2 className="accordion-header" id="heading1">
                          <button
                            className="accordion-button collapsed rounded-lg-top"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse1"
                            aria-expanded="false"
                            aria-controls="collapse1"
                            onClick={handleEditCollapse}
                          >
                            Basic info
                          </button>
                        </h2>
                        <div
                          id="collapse1"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading1"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-10"></div>
                              <div className="col-md-2">
                                {!isBasicInfoEdit && (
                                  <a
                                    style={{
                                      float: "right",
                                      fontSize: "18px",
                                      color: "blue",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setIsBasicInfoEdit(!isBasicInfoEdit)
                                    }
                                  >
                                    <i class="fa fa-edit"></i>
                                  </a>
                                )}
                              </div>
                            </div>
                            {!isBasicInfoEdit && (
                              <div className="row">
                                <div className="row">
                                  <div className="col-md-3 text-black-50">
                                    First Name
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {userData?.personalDetail?.firstName
                                      ? userData.personalDetail.firstName
                                          .charAt(0)
                                          .toUpperCase() +
                                        userData.personalDetail.firstName
                                          .slice(1)
                                          .toLowerCase()
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    Middle Name
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {userData?.personalDetail?.middleName
                                      ? userData.personalDetail.middleName
                                          .charAt(0)
                                          .toUpperCase() +
                                        userData.personalDetail.middleName
                                          .slice(1)
                                          .toLowerCase()
                                      : "-"}
                                  </div>
                                </div>

                                <div className="row ">
                                  <div className="col-md-3 text-black-50">
                                    Last Name
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {userData?.personalDetail?.lastName
                                      ? userData.personalDetail.lastName
                                          .charAt(0)
                                          .toUpperCase() +
                                        userData.personalDetail.lastName
                                          .slice(1)
                                          .toLowerCase()
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    Email Address
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {profileEmail}
                                  </div>
                                </div>

                                <div className="row ">
                                  <div className="col-md-3 text-black-50">
                                    Employee Id
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {userData?.personalDetail?.employeeId}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    Company Name
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {companyNames.options.find(
                                      (option) =>
                                        option.value ===
                                        userData?.personalDetail?.location,
                                    )?.label ||
                                      userData?.personalDetail?.location ||
                                      "-"}
                                  </div>
                                </div>
                                <div className="row mt-2 ">
                                  <div className="col-md-3 text-black-50">
                                    Project Eligibility
                                  </div>
                                  <div className="col-md-3 mb-2">
                                    {userData?.personalDetail?.isTech === true
                                      ? "Yes"
                                      : userData?.personalDetail?.isTech ===
                                          false
                                        ? "No"
                                        : "-"}
                                  </div>
                                </div>
                              </div>
                            )}
                            {isBasicInfoEdit && (
                              <form onSubmit={handleUpdateUserDetails}>
                                <div className="row mb-2">
                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">First Name</label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <input
                                      type="text"
                                      name="firstName"
                                      className="border"
                                      value={formData.firstName}
                                      onChange={handleInputChange}
                                      placeholder="Enter first name"
                                      required
                                      onKeyPress={(e) => {
                                        const inputValue = String.fromCharCode(
                                          e.charCode,
                                        );
                                        if (
                                          (e.charCode === 32 &&
                                            e.target.selectionStart === 0) ||
                                          (inputValue.match(/^\d+$/) &&
                                            e.target.selectionStart === 0)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </div>

                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">Middle Name</label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <input
                                      type="text"
                                      name="middleName"
                                      className="border "
                                      value={formData.middleName}
                                      onChange={handleInputChange}
                                      placeholder="Enter middle name"
                                      onKeyPress={(e) => {
                                        const inputValue = String.fromCharCode(
                                          e.charCode,
                                        );
                                        if (
                                          (e.charCode === 32 &&
                                            e.target.selectionStart === 0) ||
                                          (inputValue.match(/^\d+$/) &&
                                            e.target.selectionStart === 0)
                                        ) {
                                          e.preventDefault(); // only block digits at the start
                                        }
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">Last Name</label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <input
                                      type="text"
                                      name="lastName"
                                      className="border"
                                      value={formData.lastName}
                                      onChange={handleInputChange}
                                      placeholder="Enter last name"
                                      required
                                    />
                                  </div>

                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">
                                      {" "}
                                      Email Address
                                    </label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <span className="form-control-plaintext border rounded px-2 py-1">
                                      {profileEmail}
                                    </span>
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">Employee Id</label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <span className="form-control-plaintext border rounded px-2 py-1">
                                      {userData?.personalDetail?.employeeId}
                                    </span>
                                  </div>

                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">Company Name</label>
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <select
                                      id="employeeFlag"
                                      name="employeeFlag"
                                      value={formData.employeeFlag}
                                      onChange={handleInputChange}
                                      className="border"
                                      required
                                    >
                                      <option value="" disabled>
                                        {companyNames.loading
                                          ? "Loading Companies"
                                          : "Select Company Name"}
                                      </option>
                                      {companyNames.options.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-2 text-black-50">
                                    <label className="mt-2">
                                      Project Eligibility
                                    </label>
                                  </div>
                                  <div className="col-md-4  mb-2">
                                    <select
                                      id="projectEligibility"
                                      name="isTech"
                                      value={formData.isTech?.toString() || ""}
                                      onChange={handleInputChange}
                                      className="border"
                                      required
                                    >
                                      <option value="" disabled>
                                        Select Eligibility
                                      </option>
                                      {isTechnicalOptions.map((option) => (
                                        <option
                                          key={option.value}
                                          value={String(option.value)}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-10"></div>
                                  <div className="col-md-2">
                                    {isBasicInfoEdit && (
                                      <div className="action d-flex justify-content-end">
                                        <button
                                          type="submit"
                                          className={
                                            isLoading
                                              ? "btn btn-primary btn-sm disabled"
                                              : "btn btn-primary btn-sm"
                                          }
                                          onClick={(e) =>
                                            isLoadingUpdate
                                              ? e.preventDefault()
                                              : null
                                          }
                                          style={{
                                            marginLeft: "16px",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {isLoadingUpdate ? (
                                            <ThreeDots
                                              height="20"
                                              width="53"
                                              radius="9"
                                              color="white"
                                              ariaLabel="three-dots-loading"
                                              wrapperStyle={{}}
                                              wrapperClassName=""
                                              visible={true}
                                            />
                                          ) : (
                                            "Update"
                                          )}
                                        </button>
                                        <button
                                          type="button"
                                          className={
                                            "btn btn-secondary btn-sm ms-2"
                                          }
                                          style={{
                                            float: "right",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setIsBasicInfoEdit(
                                              !isBasicInfoEdit,
                                            );
                                            handleClose();
                                          }}
                                        >
                                          Close
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="heading2">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse2"
                            aria-expanded="false"
                            aria-controls="collapse2"
                            onClick={handleEditCollapse}
                          >
                            Work
                          </button>
                        </h2>
                        <div
                          id="collapse2"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading2"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-10"></div>
                              <div className="col-md-2">
                                {!isWorkEdit && (
                                  <a
                                    style={{
                                      float: "right",
                                      fontSize: "18px",
                                      color: "blue",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setIsWorkEdit(!isWorkEdit)}
                                  >
                                    <i class="fa fa-edit"></i>
                                  </a>
                                )}
                              </div>
                            </div>
                            {!isWorkEdit && (
                              <div className="row">
                                {/* Row 1: Department & Date of Joining */}
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Department</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {userData?.personalDetail?.department
                                        ? userData?.personalDetail?.department
                                        : "-"}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Date of Joining</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {formatCalendarDateDisplay(
                                        userData?.personalDetail?.doj,
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Confirmation Date</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {formatCalendarDateDisplay(
                                        getFirstDefinedField(
                                          userData?.personalDetail,
                                          "confirmationDate",
                                          "comconfirmationDate",
                                        ),
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Notice Period</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {formatNoticePeriodDays(
                                        userData?.personalDetail
                                          ?.noticePeriodDays,
                                      )}
                                      {/* {
                                        userData?.personalDetail
                                          ?.noticePeriodDays
                                      } */}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Tech Stack</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {techStacks.find(
                                        (t) =>
                                          t.name ===
                                          userData?.personalDetail?.techStack,
                                      )?.type || "-"}
                                    </p>
                                  </div>
                                </div>

                                {/* Row 2: Designation & Employee Type */}
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Designation</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {userData?.personalDetail?.designation
                                        ? userData?.personalDetail?.designation
                                        : "-"}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Employee Type</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {employeeTypeOptions.find(
                                        (opt) =>
                                          opt.value ===
                                          userData?.personalDetail
                                            ?.employeeType,
                                      )?.label || "-"}
                                    </p>
                                  </div>
                                </div>

                                {/* Row 3: Reporting Manager & Employee Sub Type */}
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Reporting Manager</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {userData?.personalDetail?.managerName
                                        ? userData?.personalDetail?.managerName
                                        : "-"}
                                    </p>
                                  </div>
                                </div>
                                {userData?.personalDetail?.employeeType ===
                                  "REGULAR" && (
                                  <div className="col-md-6 d-flex">
                                    <div className="w-50 text-black-50">
                                      <p>Employee Sub Type</p>
                                    </div>
                                    <div className="w-50">
                                      <p>
                                        {userData?.personalDetail
                                          ?.employeeSubType
                                          ? userData.personalDetail.employeeSubType.replace(
                                              "Fulltime",
                                              "Full Time",
                                            )
                                          : "-"}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Leave Manager</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {getLeaveManagerDisplayName(
                                        userData?.personalDetail,
                                        userData,
                                      )}
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Current Location</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {userData?.personalDetail?.currentLocation || "-"}
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Joining Location</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {userData?.personalDetail?.joiningLocation || "-"}
                                    </p>
                                  </div>
                                </div>
                                {/* Row 4: Status */}
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    <p>Employee Status</p>
                                  </div>
                                  <div className="w-50">
                                    <p>
                                      {displayEmployeeStatus(
                                        userData?.personalDetail?.status,
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                  <div className="w-50 text-black-50">
                                    Trailhead
                                  </div>
                                  <div
                                    className={`w-50 ${
                                      !userData?.personalDetail?.trailHead
                                        ? "ps-4"
                                        : ""
                                    }`}
                                  >
                                    {userData?.personalDetail?.trailHead || "-"}
                                  </div>
                                </div>
                                {/* Row 5: Status */}

                                <div className="col-md-6 d-flex"> </div>
                              </div>
                            )}
                            {isWorkEdit && (
                              <form onSubmit={handleUpdateUserDetails}>
                                <div className="employee-profile-field-grid mt-3">
                                  {/* Row 1: Department & Date of Joining */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Department</p>
                                      </div>
                                      <div className="w-50">
                                        <p>
                                          {userData?.personalDetail?.department
                                            ? userData?.personalDetail
                                                ?.department
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Date of Joining</p>
                                      </div>
                                      <div className="w-50">
                                        <div className="input-group">
                                          <input
                                            type="date"
                                            name="joiningDate"
                                            value={formData.joiningDate}
                                            onChange={handleInputChange}
                                            max={getMaxDate()}
                                            className="border"
                                            required
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Confirmation Date</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="date"
                                          name="confirmationDate"
                                          value={formData.confirmationDate}
                                          onChange={handleInputChange}
                                          className="border"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Notice Period</p>
                                      </div>
                                      <div className="w-50">
                                        <select
                                          className="border"
                                          value={
                                            formData.noticePeriodMode === "custom"
                                              ? "custom"
                                              : getNoticePeriodPreset(
                                                  formData.noticePeriodDays,
                                                )
                                          }
                                          onChange={
                                            handleNoticePeriodPresetChange
                                          }
                                          required
                                        >
                                          <option value="" disabled>
                                            Select Notice Period
                                          </option>
                                          {NOTICE_PERIOD_OPTIONS.map(
                                            (option) => (
                                              <option
                                                key={option.value}
                                                value={option.value}
                                              >
                                                {option.label}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      {formData.noticePeriodMode === "custom" && (
                                          <div style={{ marginTop: "8px" }}>
                                            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                                              <input
                                                type="number"
                                                className="border"
                                                style={{ flex: 1, padding: "6px" }}
                                                value={formData.noticePeriodCustomDays}
                                                onChange={handleNoticePeriodCustomDaysChange}
                                                min="1"
                                                max={
                                                  formData.noticePeriodCustomUnit === "months"
                                                    ? "12"
                                                    : "30"
                                                }
                                                placeholder={
                                                  formData.noticePeriodCustomUnit === "months"
                                                    ? "Enter months (1-12)"
                                                    : "Enter days (1-30)"
                                                }
                                                required
                                              />
                                              <select
                                                className="border"
                                                style={{ flex: 1 }}
                                                value={formData.noticePeriodCustomUnit}
                                                onChange={handleNoticePeriodCustomUnitChange}
                                                required
                                              >
                                                <option value="days">Day</option>
                                                <option value="months">Month</option>
                                              </select>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  
                                  </div>

                                  {/* Row 2: Designation & Employee Type */}
                                  <div className="row mb-2">
                                      <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Tech Stack</p>
                                      </div>

                                      <div className="w-50">
                                        <select
                                          className="border"
                                          name="techStack"
                                          value={formData.techStack}
                                          onChange={handleInputChange}
                                        >
                                          <option value="" disabled>
                                            Select Tech Stack
                                          </option>

                                          {techStacks.map((item, index) => (
                                            <option
                                              key={index}
                                              value={item.name}
                                            >
                                              {item.type}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Designation</p>
                                      </div>
                                      <div className="w-50">
                                        <p>
                                          {userData?.personalDetail?.designation
                                            ? userData?.personalDetail
                                                ?.designation
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                  
                                  </div>

                                  {/* Row 3: Reporting Manager & Employee Sub Type */}
                                  <div className="row mb-2">
                                      <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Employee Type</p>
                                      </div>
                                      <div className="w-50">
                                        <select
                                          className="border"
                                          name="employeeType"
                                          value={formData.employeeType}
                                          onChange={handleInputChange}
                                          required
                                        >
                                          <option value="" disabled>
                                            Select Employee Type
                                          </option>
                                          {employeeTypeOptions
                                            .filter((type) =>
                                              ["REGULAR", "CONSULTANT"].includes(
                                                String(type.value),
                                              ),
                                            )
                                            .map((type) => (
                                            <option
                                              key={type.value}
                                              value={type.value}
                                            >
                                              {type.label}
                                            </option>
                                            ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Reporting Manager</p>
                                      </div>
                                      <div className="w-50">
                                        <p>
                                          {userData?.personalDetail?.managerName
                                            ? userData?.personalDetail
                                                ?.managerName
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                 
                                  </div>

                                  <div className="row mb-2">
                                      {formData.employeeType === "REGULAR" && (
                                        <div className="col-md-6 d-flex">
                                          <div className="w-50 text-black-50">
                                            <p>Employee Sub Type</p>
                                          </div>
                                          <div className="w-50">
                                            <select
                                              className="border"
                                              name="employeeSubType"
                                              value={formData.employeeSubType}
                                              onChange={handleInputChange}
                                              required
                                            >
                                              <option value="" disabled>
                                                Select Employee Sub Type
                                              </option>
                                              <option value="Fulltime">
                                                Full Time
                                              </option>
                                              <option value="Intern">Intern</option>
                                            </select>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Leave Manager</p>
                                      </div>
                                      <div className="w-50">
                                        <p>
                                          {getLeaveManagerDisplayName(
                                            userData?.personalDetail,
                                            userData,
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                 
                                  </div>

                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Current Location</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="text"
                                          className="border"
                                          name="currentLocation"
                                          value={formData.currentLocation}
                                          onChange={handleInputChange}
                                          placeholder="Enter current location"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Joining Location</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="text"
                                          className="border"
                                          name="joiningLocation"
                                          value={formData.joiningLocation}
                                          onChange={handleInputChange}
                                          placeholder="Enter joining location"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 4:   */}
                                  <div className="row">
                                       <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Employee Status</p>
                                      </div>
                                      <div className="w-50">
                                        <p>
                                          {displayEmployeeStatus(
                                            userData?.personalDetail?.status,
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Trailhead</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="url"
                                          className="border"
                                          placeholder="Enter Trailhead URL"
                                          pattern="https:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.com(\/[^\/\s]+)*\/?$"
                                          name="trailHead"
                                          value={formData.trailHead}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="employee-profile-grid-actions row mt-4 pe-4">
                                  <div className="col-md-10"></div>
                                  <div className="col-md-2 justify-content-start">
                                    {isWorkEdit && (
                                      <div className="action d-flex justify-content-end">
                                        <button
                                          type="submit"
                                          className={
                                            isLoading
                                              ? "btn btn-primary btn-sm disabled"
                                              : "btn btn-primary btn-sm"
                                          }
                                          style={{
                                            marginLeft: "16px",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {isLoadingUpdate ? (
                                            <ThreeDots
                                              height="20"
                                              width="53"
                                              radius="9"
                                              color="white"
                                              ariaLabel="three-dots-loading"
                                              wrapperStyle={{}}
                                              wrapperClassName=""
                                              visible={true}
                                            />
                                          ) : (
                                            "Update"
                                          )}
                                        </button>
                                        <button
                                          type="button"
                                          className={
                                            "btn btn-secondary btn-sm ms-2"
                                          }
                                          style={{
                                            float: "right",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setIsWorkEdit(!isWorkEdit);
                                            handleClose();
                                          }}
                                        >
                                          Close
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </form>
                            )}
                            {showSqeShiftTiming && userData?.personalDetail?.id && (
                              <SqeShiftTiming employeeId={userData.personalDetail.id} />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTechStack">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTechStack"
                            aria-expanded="false"
                            aria-controls="collapseTechStack"
                          >
                            Technical Skills
                          </button>
                        </h2>
                        <div
                          id="collapseTechStack"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTechStack"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <EmployeeTechStackView
                              employeeId={userData?.personalDetail?.id ?? data}
                              embedded
                            />
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingCertifications">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseCertifications"
                            aria-expanded="false"
                            aria-controls="collapseCertifications"
                          >
                            Certifications
                          </button>
                        </h2>
                        <div
                          id="collapseCertifications"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingCertifications"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <EmployeeCertificationsView
                              employeeId={userData?.personalDetail?.id ?? data}
                              embedded
                            />
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="heading3">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse3"
                            aria-expanded="false"
                            aria-controls="collapse3"
                            onClick={handleEditCollapse}
                          >
                            Personal Details
                          </button>
                        </h2>
                        <div
                          id="collapse3"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading3"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-10"></div>
                              <div className="col-md-2">
                                {!isPersonalDetailEdit && (
                                  <a
                                    style={{
                                      float: "right",
                                      fontSize: "18px",
                                      color: "blue",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setIsPersonalDetailEdit(
                                        !isPersonalDetailEdit,
                                      )
                                    }
                                  >
                                    <i class="fa fa-edit"></i>
                                  </a>
                                )}
                              </div>
                            </div>
                            {!isPersonalDetailEdit && (
                              <div className="row">
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    {isUsEmployee ? "SSN (Social Security Number)" : "Aadhar Number"}
                                  </div>
                                  <div className="col-md-3">
                                    {(isUsEmployee ? userData?.personalDetail?.ssn : userData?.personalDetail?.aadharNum)
                                      ? (isUsEmployee ? userData?.personalDetail?.ssn : userData?.personalDetail?.aadharNum)
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    Date of Birth
                                  </div>
                                  <div className="col-md-3">
                                    {formatCalendarDateDisplay(
                                      userData?.personalDetail?.dob,
                                    )}
                                  </div>
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    Passport Number
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.passportNum
                                      ? userData?.personalDetail?.passportNum
                                      : "-"}
                                  </div>
                                  {!isUsEmployee && (
                                    <>
                                      <div className="col-md-3 text-black-50">
                                        Blood Group
                                      </div>
                                      <div className="col-md-3">
                                        {userData?.personalDetail?.bloodGroup
                                          ? userData?.personalDetail?.bloodGroup
                                          : "-"}
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    {isUsEmployee ? "ZIP Code" : "PAN Card Number"}
                                  </div>
                                  <div className="col-md-3">
                                    {(isUsEmployee ? userData?.personalDetail?.zipCode : userData?.personalDetail?.panNum)
                                      ? (isUsEmployee ? userData?.personalDetail?.zipCode : userData?.personalDetail?.panNum)
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    {" "}
                                    Gender
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.gender
                                      ? userData.personalDetail.gender
                                          .charAt(0)
                                          .toUpperCase() +
                                        userData.personalDetail.gender.slice(1)
                                      : "-"}
                                  </div>
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    Emergency Contact Number
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.alternateNumber
                                      ? userData?.personalDetail
                                          ?.alternateNumber
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    {" "}
                                    Marital Status
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.maritalStatus
                                      ? userData?.personalDetail?.maritalStatus
                                      : "-"}
                                  </div>
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    Emergency Contact Name
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.alternateName
                                      ? userData?.personalDetail?.alternateName
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    {" "}
                                    Current Residential Address
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.presentAddress
                                      ? userData?.personalDetail?.presentAddress
                                      : "-"}
                                  </div>
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    Relationship with Emergency Contact Person
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail
                                      ?.relationWithAlternateNo
                                      ? userData?.personalDetail
                                          ?.relationWithAlternateNo
                                      : "-"}
                                  </div>
                                  <div className="col-md-3 text-black-50">
                                    {" "}
                                    Permanent Address
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.permanentAddress
                                      ? userData?.personalDetail
                                          ?.permanentAddress
                                      : "-"}
                                  </div>
                                </div>
                                <div className="row mb-3 ">
                                  <div className="col-md-3 text-black-50">
                                    Personal Email Address
                                  </div>
                                  <div className="col-md-3">
                                    {userData?.personalDetail?.personalEmail ||
                                      "-"}
                                  </div>
                                </div>
                              </div>
                            )}
                            {isPersonalDetailEdit && (
                              <form onSubmit={handleUpdateUserDetails}>
                                <div className="row mt-3">
                                  {/* Row 1: Aadhar & DOB */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>{isUsEmployee ? "SSN (Social Security Number)" : "Aadhar Number"}</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type={isUsEmployee ? "text" : "tel"}
                                          required
                                          minLength={isUsEmployee ? 9 : 12}
                                          maxLength={isUsEmployee ? 9 : 12}
                                          inputMode="numeric"
                                          name={isUsEmployee ? "ssn" : "aadharNumber"}
                                          className="border"
                                          value={isUsEmployee ? formData.ssn : formData.aadharNumber}
                                          onChange={handleInputChange}
                                          placeholder={
                                            isUsEmployee
                                              ? "Enter SSN"
                                              : "Enter Aadhar number"
                                          }
                                        />
                                        {isUsEmployee && errors.ssn && (
                                          <small className="text-danger d-block">
                                            {errors.ssn}
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Date of Birth</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="date"
                                          name="dob"
                                          value={formData.dob}
                                          onChange={handleInputChange}
                                          className="border"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 2: Passport & Blood Group */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Passport Number</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="text"
                                          name="passportNumber"
                                          className="border"
                                          value={formData.passportNumber}
                                          onChange={handleInputChange}
                                          maxLength={isUsEmployee ? 9 : 8}
                                          placeholder={
                                            "Enter passport number"
                                          }
                                        />
                                        {errors.passportNumber && (
                                          <small className="text-danger d-block">
                                            {errors.passportNumber}
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    {!isUsEmployee && (
                                      <div className="col-md-6 d-flex">
                                        <div className="w-50 text-black-50">
                                          <p>Blood Group</p>
                                        </div>
                                        <div className="w-50">
                                          <select
                                            name="bloodGroup"
                                            value={formData.bloodGroup}
                                            onChange={handleInputChange}
                                            className="border"
                                          >
                                            <option value="">
                                              Select Blood Group
                                            </option>
                                            <option value="A+ve">A+ve</option>
                                            <option value="A-ve">A-ve</option>
                                            <option value="B+ve">B+ve</option>
                                            <option value="B-ve">B-ve</option>
                                            <option value="AB+ve">AB+ve</option>
                                            <option value="AB-ve">AB-ve</option>
                                            <option value="O+ve">O+ve</option>
                                            <option value="O-ve">O-ve</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Row 3: PAN & Gender */}
                                  {/* Row 3: PAN & Gender */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>{isUsEmployee ? "ZIP Code" : "PAN Card Number"}</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="text"
                                          required
                                          name={isUsEmployee ? "zipCode" : "panCardNumber"}
                                          maxLength={isUsEmployee ? 5 : 10}
                                          minLength={isUsEmployee ? 5 : 10}
                                          className="border"
                                          value={isUsEmployee ? formData.zipCode : formData.panCardNumber}
                                          onChange={handleInputChange}
                                          placeholder={
                                            isUsEmployee
                                              ? "Enter ZIP code"
                                              : "Enter PAN card number"
                                          }
                                        />
                                        {errors[
                                          isUsEmployee
                                            ? "zipCode"
                                            : "panCardNumber"
                                        ] && (
                                          <small className="text-danger">
                                            {
                                              errors[
                                                isUsEmployee
                                                  ? "zipCode"
                                                  : "panCardNumber"
                                              ]
                                            }
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Gender</p>
                                      </div>
                                      <div className="w-50">
                                        <div className="form-check form-check-inline ps-0">
                                          <input
                                            type="radio"
                                            id="male"
                                            name="gender"
                                            value="male"
                                            checked={formData.gender === "male"}
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="ps-1"
                                            htmlFor="male"
                                          >
                                            Male
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline ps-0">
                                          <input
                                            type="radio"
                                            id="female"
                                            name="gender"
                                            value="female"
                                            checked={
                                              formData.gender === "female"
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            htmlFor="female"
                                            className="ps-1"
                                          >
                                            Female
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline ps-0">
                                          <input
                                            type="radio"
                                            id="others"
                                            name="gender"
                                            value="others"
                                            checked={
                                              formData.gender === "others"
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            htmlFor="others"
                                            className="ps-1"
                                          >
                                            Others
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 4: Alternate Number & Marital Status */}
                                  {/* Row 4: Alternate Number & Marital Status */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Emergency Contact Number</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="tel"
                                          name="alternateNumber"
                                          minLength="10"
                                          maxLength="10"
                                          value={formData.alternateNumber}
                                          onChange={handleInputChange}
                                          className="border"
                                          placeholder="Enter emergency contact number"
                                          required
                                        />
                                        {errors.alternateNumber && (
                                          <small className="text-danger d-block">
                                            {errors.alternateNumber}
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Marital Status</p>
                                      </div>
                                      <div className="w-50">
                                        <select
                                          id="maritalStatus"
                                          value={formData.maritalStatus}
                                          required
                                          onChange={handleInputChange}
                                          name="maritalStatus"
                                          className="border"
                                        >
                                          <option value="">
                                            Select Marital Status
                                          </option>
                                          <option value="Single">Single</option>
                                          <option value="Married">
                                            Married
                                          </option>
                                          <option value="Widowed">
                                            Widowed
                                          </option>
                                          <option value="Separated">
                                            Separated
                                          </option>
                                          <option value="Divorced">
                                            Divorced
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 5: Alternate Name & Present Address */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Emergency Contact Name</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="text"
                                          name="alternateName"
                                          value={formData.alternateName}
                                          onChange={handleInputChange}
                                          className="border"
                                          placeholder="Enter emergency contact name"
                                        />
                                        {errors.alternateName && (
                                          <small className="text-danger d-block">
                                            {errors.alternateName}
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Current Residential Address</p>
                                      </div>
                                      <div className="w-50">
                                        <textarea
                                          name="presentAddress"
                                          value={formData.presentAddress}
                                          onChange={handleInputChange}
                                          className="border"
                                          rows={4}
                                          placeholder="Enter current residential address"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 6: Relationship & Permanent Address */}
                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>
                                          Relationship with Emergency Contact
                                          Person
                                        </p>
                                      </div>
                                      <div className="w-50">
                                        <select
                                          name="relationWithAlternateNo"
                                          value={
                                            formData.relationWithAlternateNo
                                          }
                                          onChange={handleInputChange}
                                          className="border"
                                        >
                                          <option value="">Select Relation</option>
                                          {emergencyContactRelationOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.relationWithAlternateNo && (
                                          <small className="text-danger d-block">
                                            {errors.relationWithAlternateNo}
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Permanent Address</p>
                                      </div>
                                      <div className="w-50">
                                        <textarea
                                          name="permanentAddress"
                                          value={formData.permanentAddress}
                                          onChange={handleInputChange}
                                          className="border"
                                          rows={4}
                                          placeholder="Enter permanent address"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row mb-2">
                                    <div className="col-md-6 d-flex">
                                      <div className="w-50 text-black-50">
                                        <p>Personal Email Address</p>
                                      </div>
                                      <div className="w-50">
                                        <input
                                          type="email"
                                          name="personalEmail"
                                          value={formData.personalEmail}
                                          onChange={handleInputChange}
                                          className="border"
                                          placeholder="Enter personal email address"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-md-10"></div>
                                  <div className="col-md-2">
                                    {isPersonalDetailEdit && (
                                      <div className="action d-flex justify-content-end">
                                        <button
                                          type="submit"
                                          className={
                                            isLoading
                                              ? "btn btn-primary btn-sm disabled"
                                              : "btn btn-primary btn-sm"
                                          }
                                          onClick={(e) =>
                                            isLoadingUpdate
                                              ? e.preventDefault()
                                              : null
                                          }
                                          style={{
                                            marginLeft: "16px",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {isLoadingUpdate ? (
                                            <ThreeDots
                                              height="20"
                                              width="53"
                                              radius="9"
                                              color="white"
                                              ariaLabel="three-dots-loading"
                                              wrapperStyle={{}}
                                              wrapperClassName=""
                                              visible={true}
                                            />
                                          ) : (
                                            "Update"
                                          )}
                                        </button>
                                        <button
                                          type="button"
                                          className={
                                            "btn btn-secondary btn-sm ms-2"
                                          }
                                          style={{
                                            float: "right",
                                            fontSize: "17px",
                                            fontWeight: "bolder",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setIsPersonalDetailEdit(
                                              !isPersonalDetailEdit,
                                            );
                                            handleClose();
                                          }}
                                        >
                                          Close
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="heading4">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse4"
                            aria-expanded="false"
                            aria-controls="collapse4"
                          >
                            Work Experience
                          </button>
                        </h2>
                        <div
                          id="collapse4"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading4"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-12">
                                {userData?.experience?.length === 0 ? (
                                  <div className="fs-4 text-secondary text-center">
                                    No records available
                                  </div>
                                ) : (
                                  <SortableTable
                                    className="resume custom"
                                    data={userData?.experience || []}
                                    columns={experienceColumns}
                                  />
                                )}
                                {/* <WorkExperience workData={userData?.experience} /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="heading5">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse5"
                            aria-expanded="false"
                            aria-controls="collapse5"
                          >
                            Education
                          </button>
                        </h2>
                        <div
                          id="collapse5"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading5"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-12">
                                {userData?.education?.length === 0 ? (
                                  <div className="fs-4 text-secondary text-center">
                                    No records available
                                  </div>
                                ) : (
                                  <SortableTable
                                    className="resume custom"
                                    data={userData?.education || []}
                                    columns={educationColumns}
                                  />
                                )}

                                {/* <Education educationData={userData?.education} /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item last-accordion-item  rounded-lg-bottom">
                        <h2 className="accordion-header" id="heading6">
                          <button
                            className="accordion-button collapsed rounded-lg-bottom"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse6"
                            aria-expanded="false"
                            aria-controls="collapse6"
                          >
                            Dependents
                          </button>
                        </h2>
                        <div
                          id="collapse6"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading6"
                          data-bs-parent="#accordion1"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-12">
                                {userData?.dependents?.length === 0 ? (
                                  <div className="fs-4 text-secondary text-center">
                                    No records available
                                  </div>
                                ) : (
                                  <SortableTable
                                    className="resume custom"
                                    data={userData?.dependents || []}
                                    columns={dependentsColumns}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="tab2"
                    role="tabpanel"
                    aria-labelledby="tab2-tab"
                  ></div>

                  <div
                    className="tab-pane fade"
                    id="tab3"
                    role="tabpanel"
                    aria-labelledby="tab3-tab"
                  ></div>

                  <div
                    className="tab-pane fade"
                    id="tab4"
                    role="tabpanel"
                    aria-labelledby="tab4-tab"
                  >
                    <EmployeeAsset
                      assestData={userData?.assestDetail}
                      employeeId={data}
                    />
                  </div>

                  {showBankDetailsTab ? (
                    <div
                      className="tab-pane fade"
                      id="tab13"
                      role="tabpanel"
                      aria-labelledby="tab13-tab"
                    >
                      <ProfileBankDetails
                        employeeId={userData?.personalDetail?.id ?? data}
                        accessToken={accessToken}
                      />
                    </div>
                  ) : null}

                  <div
                    className="tab-pane fade"
                    id="tab14"
                    role="tabpanel"
                    aria-labelledby="tab14-tab"
                  >
                    {documentUploadLoading ? (
                      <div className="d-flex justify-content-center align-items-center py-5">
                        <ThreeDots
                          height="64"
                          width="64"
                          color="var(--color-accent-500)"
                          visible
                        />
                      </div>
                    ) : null}
                    <div
                      style={{
                        display: documentUploadLoading ? "none" : "block",
                      }}
                    >
                      <UploadDocument
                        employeeId={userData?.personalDetail?.id ?? data}
                        embedded
                        onLoadingChange={setDocumentUploadLoading}
                      />
                    </div>
                  </div>

                  {showInsuranceDetailsTab ? <div
                    className="tab-pane fade"
                    id="tab15"
                    role="tabpanel"
                    aria-labelledby="tab15-tab"
                  >
                    <EmployeeInsuranceTab
                      insuranceDetails={insuranceDetails}
                      loading={insuranceDetailsLoading}
                      employeeId={userData?.personalDetail?.id ?? data}
                      location={userData?.personalDetail?.location}
                      employeeType={
                        userData?.personalDetail?.employeeType ??
                        userData?.personalDetail?.empType
                      }
                      maritalStatus={
                        insuranceDetails?.maritalStatus ??
                        userData?.personalDetail?.maritalStatus
                      }
                      onInsuranceUpdated={setInsuranceDetails}
                      onInsuranceSaved={() =>
                        setInsuranceRefreshKey((current) => current + 1)
                      }
                    />
                  </div> : null}

                  <div
                    className="tab-pane fade"
                    id="tab5"
                    role="tabpanel"
                    aria-labelledby="tab5-tab"
                  >
                    <OrgChartExample />
                  </div>

                  <div
                    className="tab-pane fade"
                    id="tab6"
                    role="tabpanel"
                    aria-labelledby="tab6-tab"
                  ></div>

                  <div
                    className="tab-pane fade"
                    id="tab7"
                    role="tabpanel"
                    aria-labelledby="tab7-tab"
                  ></div>

                  <div
                    className="tab-pane fade"
                    id="tab8"
                    role="tabpanel"
                    aria-labelledby="tab8-tab"
                  >
                    <Salary />
                  </div>
                  {/* <div
                    className="tab-pane fade"
                    id="tab9"
                    role="tabpanel"
                    aria-labelledby="tab9-tab"
                  >
                    <IndexChart />
                  </div> */}
                  <div
                    className="tab-pane fade"
                    id="tab10"
                    role="tabpanel"
                    aria-labelledby="tab10-tab"
                  >
                    <EmployeeType userData={userData?.personalDetail} />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab11"
                    role="tabpanel"
                    aria-labelledby="tab11-tab"
                  >
                    <EmployeeAccess userData={userData?.personalDetail} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          // </form>
        )}
        <Footer />
      </div>
      <div
        className="modal fade"
        id="staticBackdropEmp"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <EditEmployee
              selectedEmployee={userData}
              // fetchList={fetchApprovedUser}
              titleHeading="Edit Employee Action"
              isEditable={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeProfile;
